/**
 * Stable CSS class names for E2E — Customer order information paper.
 */
export const COIP = {
    page: 'customer-order-information-paper-page',
    searchRow: 'customer-order-information-paper__search-row',
    inputCompositeSearch: 'customer-order-information-input--composite-search',
    fieldContactReason: 'customer-order-information-field--contact-reason',
    inputSelectContactReason: 'customer-order-information-input--select-contact-reason',

    mainPaper: 'customer-order-information-paper__main-paper',
    tableSection: 'customer-order-information-paper__table-section',
    tableContainer: 'customer-order-information-paper__table-container',

    inputIconButtonExpandRow: 'customer-order-information-input--icon-button-expand-row',
    inputLinkOrderNumber: 'customer-order-information-input--link-order-number',
    inputLinkShippingNumber: 'customer-order-information-input--link-shipping-number',
    fieldElapsedTimeBadge: 'customer-order-information-field--elapsed-time-badge',
    fieldChipOrderStatus: 'customer-order-information-field--chip-order-status',
    inputIconButtonRowMenu: 'customer-order-information-input--icon-button-row-menu',
    inputMenuItemGoToDetail: 'customer-order-information-input--menu-item-go-to-detail',
    inputMenuItemCreateRefund: 'customer-order-information-input--menu-item-create-refund',
    nestedTableWrapper: 'customer-order-information-paper__nested-table-wrapper',
    inputLinkProductDetail: 'customer-order-information-input--link-product-detail',
} as const;

export const coipCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
